

export default {
    props: {
        hint: {
            type: Object,
            default: null
        },
        hideNext: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: 'default'
        }
    },
    data () {
        return {
            messages: this.hint?.message.split('\n')
        }
    },
    watch: {
        hint () {
            this.messages = this.hint?.message.split('\n')
        }
    }
}
